import logo from "../../assets/logo_dark.png";
import logo_white from "../../assets/logo.png";
import ic_user from "../../assets/icons/ic_user.svg";
import ic_exercise from "../../assets/icons/ic_exercise.svg";
import ic_exercise_red from "../../assets/icons/ic_exercise_red.svg";
import ic_exercise_black from "../../assets/icons/ic_exercise_black.svg";
import ic_setting from "../../assets/icons/ic_setting.svg";
import ic_logout from "../../assets/icons/ic_logout.svg";
import ic_user_white from "../../assets/icons/ic_user_white.svg";
import ic_user_red from "../../assets/icons/ic_user_red.svg";
import ic_plans from "../../assets/icons/ic_plans.svg";
import ic_plans_red from "../../assets/icons/ic_plans_red.svg";
import ic_badge_achievement from "../../assets/icons/ic_badge_achievement.svg";
import ic_badge_reminder from "../../assets/icons/ic_badge_reminder.svg";
import ic_badge_blog from "../../assets/icons/ic_badge_blog.svg";
import chevron_down from "../../assets/icons/chevron_down.svg";
import IconButton from "../basic/IconButton";
import { Fragment, useState } from "react";
import AuthDialog from "../auth/AuthDialog";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import Button from "../basic/Button";
import { Dialog, Popover, Transition } from "@headlessui/react";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import {
  BlueLinearGradient,
  BlueTextLinearGradient,
  WhiteLinearGradient,
  WhiteTextLinearGradient,
} from "../../utils/Utils";
import { useAppContext } from "../../context/AppContext";
import CustomDialog from "../basic/Dialog";

function Header() {
  const auth = useAuthContext();
  const [showAuthDialog, setShowAuthDialog] = useState(false);
  // const [coins, setCoins] = useState();
  // const [rank, setRank] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  function HeaderElement({
    icon,
    iconSelected,
    iconEnd,
    title,
    selectionPage,
    onClick,
  }) {
    return (
      <button
        className={`${
          location.pathname == selectionPage
            ? "text-primary-blue border-primary-blue  dark:border-primary-white"
            : "border-primary-white text-primary-lightBlue dark:border-primary-darkBlue"
        } h-full border-b-4 space-x-3 text-xl dark:text-primary-white flex items-center justify-center font-medium `}
        onClick={onClick}
      >
        {title && <p className={`focus:outline-none`}>{title}</p>}
      </button>
    );
  }

  const appState = useAppContext();
  const [showFullHeaderMenu, setShowFullHeaderMenu] = useState(false);

  return (
    <div
      className={`flex flex-row w-full h-16 ${
        auth.state.user
          ? "bg-primary-white dark:bg-[#25272D]"
          : "bg-primary-midBlack bg-opacity-90"
      } px-5 md:px-16 lg:px-24 2xl:px-32 items-center`}
    >
      <Link to={"/"} className="hidden md:flex items-center py-4">
        <img
          src={
            !auth.state.user
              ? logo_white
              : appState.state.darkMode
              ? logo_white
              : logo
          }
          className="h-12"
        />
      </Link>
      <Link
        to={auth.state.user ? "/programpage" : "/"}
        className="md:hidden flex items-center py-4"
      >
        <img
          src={
            !auth.state.user
              ? logo_white
              : appState.state.darkMode
              ? logo_white
              : logo
          }
          className="h-10"
        />
      </Link>
      {location.pathname === "/login" ? null : !auth.state.user ? (
        <>
          <div className="hidden lg:flex flex-1 space-x-10 items-center justify-end">
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                if (location.pathname != "/") {
                  navigate("/#how-it-works");
                  return;
                }
                document.getElementById("section-how-it-works").scrollIntoView({
                  behavior: "smooth",
                });
              }}
              id="heading-how-it-works"
            >
              AI Fitness
            </div>
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                navigate("/about-us");
              }}
            >
              About us
            </div>
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                navigate("/fitnessage");
              }}
            >
              Fitness Age
            </div>
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                if (location.pathname != "/") {
                  navigate("/#features");
                  return;
                }
                document.getElementById("section-features").scrollIntoView({
                  behavior: "smooth",
                });
              }}
              id="heading-features"
            >
              Features
            </div>
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                if (location.pathname != "/") {
                  navigate("/#cohorts");
                  return;
                }
                document.getElementById("section-cohorts").scrollIntoView({
                  behavior: "smooth",
                });
              }}
              id="heading-cohorts"
            >
              Is it for you?
            </div>
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                if (location.pathname != "/") {
                  navigate("/#comparisons");
                  return;
                }
                document.getElementById("section-comparison").scrollIntoView({
                  behavior: "smooth",
                });
              }}
              id="heading-comparison"
            >
              Compare
            </div>

            {/* Pricing Page */}
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                navigate("/subscription");
              }}
            >
              Pricing
            </div>

            <div
              className="text-black cursor-pointer text-sm rounded bg-primary-neonGreen px-5 py-2"
              onClick={() => {
                setShowAuthDialog(true);
              }}
            >
              Login
            </div>
          </div>
          <div className="flex flex-1 md:hidden" />
          <Icon
            icon="ci:hamburger"
            className="flex lg:hidden align-middle text-primary-neonGreen w-8 h-8"
            onClick={() => {
              setShowFullHeaderMenu(true);
            }}
          />
          <Transition.Root
            show={showFullHeaderMenu}
            as={Fragment}
            class={`${appState.state.darkMode ? "dark" : " "} relative z-30`}
          >
            <Dialog as="div" className="relative z-10" onClose={() => {}}>
              <div class="fixed inset-0 overflow-hidden">
                <div class="absolute inset-0 overflow-hidden">
                  <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
                    <Transition.Child
                      as={Fragment}
                      enter="transform transition ease-in-out duration-300"
                      enterFrom="translate-x-full"
                      enterTo="translate-x-0"
                      leave="transform transition ease-in-out duration-300"
                      leaveFrom="translate-x-0"
                      leaveTo="translate-x-full"
                    >
                      <Dialog.Panel className="pointer-events-auto relative w-screen max-w-md">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-in-out duration-300"
                          enterFrom="opacity-0"
                          enterTo="opacity-100"
                          leave="ease-in-out duration-300"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <div
                            class={`flex h-full flex-col shadow-xl 
                  w-full bg-primary-midBlack p-8`}
                          >
                            <div className="flex flex-row items-center">
                              <Link to={"/"} className="flex items-center py-4">
                                <img
                                  src={
                                    !auth.state.user
                                      ? logo_white
                                      : appState.state.darkMode
                                      ? logo_white
                                      : logo
                                  }
                                  className="h-10"
                                />
                              </Link>
                              <div className="flex flex-1 md:hidden" />
                              <Icon
                                icon="akar-icons:cross"
                                className="flex align-middle text-primary-neonGreen w-6 h-6"
                                onClick={() => {
                                  setShowFullHeaderMenu(false);
                                }}
                              />
                            </div>
                            <div className="flex flex-col flex-1 gap-5 mt-10">
                              <div
                                className="text-white cursor-pointer text-lg font-medium"
                                onClick={() => {
                                  if (location.pathname != "/") {
                                    navigate("/#about-us");
                                    return;
                                  }
                                  document
                                    .getElementById("section-about-us")
                                    .scrollIntoView({
                                      behavior: "smooth",
                                    });
                                  setShowFullHeaderMenu(false);
                                }}
                              >
                                About us
                              </div>
                              <div
                                className="text-white cursor-pointer text-lg font-medium"
                                onClick={() => {
                                  if (location.pathname != "/") {
                                    navigate("/#features");
                                    return;
                                  }
                                  document
                                    .getElementById("section-features")
                                    .scrollIntoView({
                                      behavior: "smooth",
                                    });
                                  setShowFullHeaderMenu(false);
                                }}
                              >
                                Features
                              </div>
                              <div
                                className="text-white cursor-pointer text-lg font-medium"
                                onClick={() => {
                                  if (location.pathname != "/") {
                                    navigate("/#how-it-works");
                                    return;
                                  }
                                  document
                                    .getElementById("section-how-it-works")
                                    .scrollIntoView({
                                      behavior: "smooth",
                                    });
                                  setShowFullHeaderMenu(false);
                                }}
                              >
                                How does it work?
                              </div>
                              <div
                                className="text-white cursor-pointer text-lg font-medium"
                                onClick={() => {
                                  if (location.pathname != "/") {
                                    navigate("/#cohorts");
                                    return;
                                  }
                                  document
                                    .getElementById("section-cohorts")
                                    .scrollIntoView({
                                      behavior: "smooth",
                                    });
                                  setShowFullHeaderMenu(false);
                                }}
                              >
                                Is it for you?
                              </div>

                              {/* Pricing Page */}
                              <div
                                className="text-white cursor-pointer text-lg font-medium"
                                onClick={() => {
                                  navigate("/subscription");
                                }}
                              >
                                Is it for you?
                              </div>

                              <div className="flex flex-1"></div>
                              <div
                                className="text-black text-center cursor-pointer text-sm rounded bg-primary-neonGreen px-5 py-2"
                                onClick={() => {
                                  setShowFullHeaderMenu(false);
                                  setShowAuthDialog(true);
                                }}
                              >
                                Sign In
                              </div>
                            </div>
                          </div>
                        </Transition.Child>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </>
      ) : (
        <div className="flex flex-1 flex-row h-full">
          <div className="flex flex-1 mx-5" />
          <div className="hidden lg:block ">
            <div className=" flex flex-row space-x-10 h-full">
              <HeaderElement
                icon={ic_exercise}
                iconSelected={ic_exercise_red}
                selectionPage={"/programpage"}
                title="Programs"
                onClick={() => {
                  navigate("programpage");
                }}
              />
              <HeaderElement
                icon={ic_exercise}
                iconSelected={ic_exercise_red}
                selectionPage={"/routines"}
                title="Routines"
                onClick={() => {
                  navigate("routines");
                }}
              />
              <HeaderElement
                icon={ic_exercise}
                iconSelected={ic_exercise_red}
                selectionPage={"/practice"}
                title="Exercises"
                onClick={() => {
                  navigate("practice");
                }}
              />
              <HeaderElement
                icon={ic_exercise}
                iconSelected={ic_exercise_red}
                selectionPage={"/performance"}
                title="Performance"
                onClick={() => {
                  navigate("performance");
                }}
              />
              {/* <HeaderElement
                icon={ic_exercise}
                iconSelected={ic_exercise_red}
                selectionPage={"/subscription"}
                title="Pricing"
                onClick={() => {
                  navigate("subscription");
                }}
              /> */}
              <Popover className={"relative focus:outline-none h-full"}>
                <Popover.Button className={"h-full"}>
                  <button
                    className={`${
                      location.pathname == "/profile"
                        ? "text-primary-blue border-primary-blue  dark:border-primary-white"
                        : "border-primary-white text-primary-lightBlue dark:border-primary-darkBlue"
                    } h-full border-b-4 space-x-3 dark:text-primary-white text-xl flex items-center justtify-center font-medium `}
                  >
                    {auth.state.user?.avatar ? (
                      <img
                        src={auth.state.user?.avatar}
                        className="rounded-full h-10 object-cover w-10"
                      />
                    ) : (
                      <div
                        className={`${BlueLinearGradient} rounded-full h-10 w-10 flex items-center justify-center`}
                      >
                        <p
                          className={`font-medium text-2xl ${WhiteTextLinearGradient}`}
                        >
                          {auth.state.user?.fullname
                            ? auth.state.user?.fullname[0]
                            : ""}
                        </p>
                      </div>
                    )}

                    {
                      <p className={`focus:outline-none`}>
                        {auth.state.user?.fullname}
                      </p>
                    }
                    <Icon
                      icon={"akar-icons:chevron-down"}
                      className={`dark:text-primary-white text-primary-lightBlue h-4 w-auto`}
                    />
                  </button>
                </Popover.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-0"
                  enterTo="opacity-100 translate-y-1"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-1"
                  leaveTo="opacity-0 translate-y-0"
                >
                  <Popover.Panel
                    className={`absolute z-20 w-80 mt-3 -ml-44 focus:outline-none py-6 flex flex-col shadow-3xl ${WhiteLinearGradient} rounded-xl`}
                  >
                    {({ close }) => (
                      <div className="flex flex-col">
                        <div className="flex flex-col items-center space-y-2">
                          {auth.state.user?.avatar ? (
                            <img
                              src={auth.state.user?.avatar}
                              className="rounded-full h-24 object-cover w-24"
                            />
                          ) : (
                            <div
                              className={`${BlueLinearGradient} rounded-full h-24 w-24 flex items-center justify-center`}
                            >
                              <p
                                className={`font-medium text-4xl ${WhiteTextLinearGradient}`}
                              >
                                {auth.state.user?.fullname[0]}
                              </p>
                            </div>
                          )}

                          <p
                            className={`focus:outline-none font-medium text-xl ${BlueTextLinearGradient}`}
                          >
                            {auth.state.user?.fullname}
                          </p>
                          <p
                            className={`focus:outline-none font-medium text-primary-gray`}
                          >
                            {auth.state.user?.email}
                          </p>
                        </div>
                        <div className="h-[1px] bg-[#C4C4C480] my-4"></div>
                        <div className="space-y-4 px-12 mt-3">
                          <div
                            className="flex flex-row items-center hover:cursor-pointer"
                            onClick={() => {
                              navigate("profile");
                              close();
                            }}
                          >
                            <Icon
                              icon="bi:person"
                              className="h-5 text-primary-gray"
                            />
                            <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                              My Profile
                            </p>
                          </div>
                          <div
                            className="flex flex-row items-center hover:cursor-pointer"
                            onClick={() => {
                              navigate("settings");
                              close();
                            }}
                          >
                            <Icon
                              icon="ri:money-dollar-circle-fill"
                              className="h-8 text-primary-gray"
                            />
                            <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                              billing
                            </p>
                          </div>
                          <div
                            className="flex flex-row items-center hover:cursor-pointer"
                            onClick={() => {
                              if (appState.state.darkMode)
                                appState.toggleDarkMode();
                              auth.logout();
                              close();
                              navigate("/");
                              toast("Logout Successful");
                            }}
                          >
                            <Icon
                              icon="ic:round-logout"
                              className="h-5 text-[#FF3F3F]"
                            />
                            <p className="font-medium pl-4 text-sm text-[#FF3F3F] flex-1 uppercase">
                              Logout
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </Popover.Panel>
                </Transition>
              </Popover>
              {/* <Icon
                icon={
                  appState.state.darkMode ? "clarity:sun-line" : "carbon:moon"
                }
                className=" h-5 w-auto self-center cursor-pointer"
                color={appState.state.darkMode ? "#fff" : "#0B28AC"}
                onClick={() => {
                  appState.toggleDarkMode();
                }}
              /> */}
              {/* <p className="flex items-center font-medium text-xl text-primary-white flex-1 -mt-1">
            <a href="/subscription">Pricing</a>
          </p> */}
            </div>
          </div>
          <div className="lg:hidden flex flex-row gap-5">
            {/* <HeaderElement
              icon={ic_plans}
              iconSelected={ic_plans_red}
              selectionPage={"/subscription"}
              title="Plans"
              onClick={() => {
                navigate("subscription");
              }}
            /> */}
            <Icon
              icon={
                appState.state.darkMode ? "clarity:sun-line" : "carbon:moon"
              }
              className=" h-5 w-auto self-center cursor-pointer"
              color={appState.state.darkMode ? "#fff" : "#0B28AC"}
              onClick={() => {
                appState.toggleDarkMode();
              }}
            />
            <Popover className={"relative focus:outline-none"}>
              <Popover.Button className={"h-full"}>
                <IconButton
                  icon={null}
                  iconEnd={chevron_down}
                  text={null}
                  className="flex justify-center items-center"
                />
              </Popover.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-0"
                enterTo="opacity-100 translate-y-1"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-1"
                leaveTo="opacity-0 translate-y-0"
              >
                <Popover.Panel
                  className={`absolute z-20 w-80 mt-3 -ml-72 focus:outline-none py-6 flex flex-col shadow-3xl ${WhiteLinearGradient} rounded-xl`}
                >
                  {({ close }) => (
                    <div className="flex flex-col">
                      {auth.state.user && (
                        <div className="flex flex-col items-center space-y-2">
                          {auth.state.user?.avatar ? (
                            <img
                              src={auth.state.user?.avatar}
                              className="rounded-full h-24 object-cover w-24"
                            />
                          ) : (
                            <div
                              className={`${BlueLinearGradient} rounded-full h-24 w-24 flex items-center justify-center`}
                            >
                              <p
                                className={`font-medium text-4xl ${WhiteTextLinearGradient}`}
                              >
                                {auth.state.user?.fullname[0]}
                              </p>
                            </div>
                          )}

                          <p
                            className={`focus:outline-none font-medium text-xl ${BlueTextLinearGradient}`}
                          >
                            {auth.state.user?.fullname}
                          </p>
                          <p
                            className={`focus:outline-none font-medium text-primary-gray`}
                          >
                            {auth.state.user?.email}
                          </p>
                        </div>
                      )}
                      <div className="h-[1px] bg-[#C4C4C480] my-4"></div>
                      <div className="space-y-4 px-12 mt-3">
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("profile");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            My Profile
                          </p>
                        </div>
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            // navigate("exercise");
                            navigate("programpage");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            Programs
                          </p>
                        </div>
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("routines");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            Routines
                          </p>
                        </div>
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("practice");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            Exercises
                          </p>
                        </div>
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("newperformance");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            Performance
                          </p>
                        </div>
                        {/* <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("subscription");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                          Pricing
                        
                          </p>
                        </div> */}
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("settings");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            Settings
                          </p>
                        </div>
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            if (appState.state.darkMode)
                              appState.toggleDarkMode();
                            auth.logout();
                            close();
                            navigate("/");
                            toast("Logout Successful");
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-[#FF3F3F] flex-1 uppercase">
                            Logout
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </Popover.Panel>
              </Transition>
            </Popover>
          </div>
        </div>
      )}

      <AuthDialog open={showAuthDialog} setOpen={setShowAuthDialog} />
    </div>
  );
}

export default Header;
